/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/item-categories'

const ItemCategoryEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchItemCategories: builder.query<any, any>({
      query: (params) => ({
        url: `${basePath}`,
        params,
      }),
      providesTags: ['itemCategories']
    }),

    fetchItemCategoriesList: builder.query<any, void>({
      query: () => `${basePath}/list`,
      providesTags: ['itemCategories']
    }),

    createItemCategory: builder.mutation<any, any>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['itemCategories']
    }),

    updateItemCategory: builder.mutation<any, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${basePath}/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['itemCategories']
    }),

    deleteItemCategory: builder.mutation<any, string>({
      query: (id) => ({
        url: `${basePath}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['itemCategories']
    }),
  })

export default ItemCategoryEndpoints
